<template>
    <section class="sign-in">
        <div class="bg-right bg-dark"></div>
        <LoginIntro/>
        <div class="login">
            <div class="login__logo">
                <logo width="100%" height="100%" />
            </div>
            <div class="login__inner">
                <LoginHeader/>
                <LoginBody/>
                <LoginFooter/>
            </div>
        </div>
        <StudioFooter :is-light="true" :is-member="true"/>
    </section>

</template>
<script>
    import LoginIntro from './LoginIntro'
    import LoginHeader from './LoginHeader'
    import LoginBody from './LoginBody'
    import LoginFooter from './LoginFooter'
    import StudioFooter from "../StudioFooter";
    export default {
        components: {
            LoginIntro,
            LoginHeader,
            LoginBody,
            LoginFooter,
            StudioFooter,
        }
    }
</script>

<style lang="sass" scoped>
    .sign-in
        position: relative
        width: 100%
        height: 100%
        display: flex
        padding-bottom: 100px
        +r(1024)
            flex-direction: column
            padding-bottom: 0
        &:before,
        &:after
            position: absolute
            top: 0
            left: 0
            content: ''
            width: 55.5%
            height: 100%
            +r(1024)
                width: 101%
        &:before
            background-image: url('~@/assets/images/studio/login-bg.jpg')
            +cover
            z-index: 1
        &:after
            z-index: 2
            display: block
            background: linear-gradient(269.26deg, rgba(11, 35, 76, 0.82) 0.72%, rgba(23, 67, 125, 0.67) 99.25%)
            opacity: 0.9
            +tr(all .3s ease)
            +r(1024)
                background: linear-gradient(269.26deg, rgba(14, 42, 88, 0.9) 0.72%, rgba(11, 35, 75, 0.85) 99.25%)
                opacity: 1
    .bg-right
        position: absolute
        top: 0
        right: 0
        width: 45.6%
        height: 100%
        +r(1024)
            display: none
    .login
        position: relative
        z-index: 4
        width: 45.6%
        height: 100%
        color: $color--white
        display: flex
        justify-content: center
        align-items: center
        &__inner
            width: 100%
            padding-left: (100 / 550) * 100%
            padding-right: (151/ 550) * 100%
            +r(1339)
                max-width: 350px
                padding: 0
            +xs
                max-width: 100%
        +r(1024)
            background: none
            width: 100%
            padding: 20px
        &__logo
            position: absolute
            top: 20px
            left: 36px
            width: 105px
            height: 24px
            +r(991)
                display: none
            +rmin(1025)
                display: none

    .footer
        position: absolute
        bottom: 0
        z-index: 99
        width: 100%
        +r(1024)
            position: static
</style>